import { Text, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';
import { ActivityIndicator } from 'react-native';

export namespace RateManagementPillButtonTypes {
  export interface Props {
    isMobile: boolean;
  }
}
export const FeedbackLoading: React.FC<RateManagementPillButtonTypes.Props> = ({ isMobile }) => {
  return (
    <Box
      flexDirection={isMobile ? 'column' : 'row'}
      paddingX={Spacing['stack.xxxs']}
      alignItems={'center'}>
      <ActivityIndicator size={'large'} color={Color['brand.primary.principal']} />
      <VStack
        paddingTop={isMobile ? Spacing['stack.xxxs'] : 0}
        paddingLeft={Spacing['stack.xxxs']}
        space={Spacing['stack.quarck']}>
        <Text
          testID={'title'}
          variant="semibold"
          fontSize={Typography['fontsize.xl']}
          color={['neutral.black']}>
          Aguarde enquanto estamos processando sua solicitação.
        </Text>
        <Text
          testID={'description'}
          variant="regular"
          fontSize={Typography['fontsize.md']}
          color={['neutral.black']}>
          Este processo pode levar alguns segundos, não saia desta página.
        </Text>
      </VStack>
    </Box>
  );
};
